import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { BaseHttpService } from './base-http.service';

import { User, Permission, ChangePassword } from '../models';

@Injectable()

export class AccountsService extends BaseHttpService<any> {
  constructor(private http: HttpClient) {
    super();
  }

  login(userName, password) {
    return this.http
      .post(this.getApiURI() + '/Account/Login', JSON.stringify({ userName, password }))
      .catch(this.handleError);
  }

  resetPassword(email, password, confirmPassword, code) {
    return this.http
      .post(this.getApiURI() + '/Account/ResetPassword', JSON.stringify({ email, password, confirmPassword, code }))
      .catch(this.handleError);
  }

  forgotPassword(email: string) {
    return this.http
      .post(this.getApiURI() + '/Account/ForgotPassword', JSON.stringify({ email }))
      .catch(this.handleError);
  }

  changePassword(model: ChangePassword) {
    return this.http
      .post(this.getApiURI() + '/Account/ChangePassword', JSON.stringify(model))
      .catch(this.handleError);
  }

  updateProfile(model: User): Observable<User> {
    return this.http
      .post(this.getApiURI() + '/Account/UpdateProfile', JSON.stringify(model))
      .catch(this.handleError);
  }

  getUser(): Observable<User> {
    return this.http
      .get(this.getApiURI() + '/account/getuser')
      .catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/data/accounts.service.ts